export type SortArrayConfig<T, R = T> = {
  keySelector: (item: T) => string
  keyIndex: Array<string>
  resultSelector: (item: T) => R
  direction?: 'asc' | 'desc'
}

export const sortArray = <T, R = T>(
  array: Array<T>,
  {
    keyIndex,
    keySelector,
    direction = 'asc',
    resultSelector,
  }: SortArrayConfig<T, R>
): R[] => {
  const keySet = new Set(keyIndex)
  if (keySet.size !== keyIndex.length) {
    throw new Error('Duplicate keys detected in keyIndex')
  }

  const indexMap = new Map(keyIndex.map((key, index) => [key, index]))
  const sorted = array.slice().sort((a, b) => {
    const aIndex = indexMap.get(keySelector(a))
    const bIndex = indexMap.get(keySelector(b))
    if (aIndex === undefined || bIndex === undefined) {
      return 0
    }
    return direction === 'asc' ? aIndex - bIndex : bIndex - aIndex
  })

  return sorted.map(resultSelector)
}
